











import { Component, Vue } from 'vue-property-decorator'
import ffButton from '@/components/public/Button.vue'
import { namespace } from 'vuex-class'

const appStore = namespace('app')
@Component({
  components: {
    ffButton
  }
})
export default class Layout extends Vue {
  @appStore.State(state => state.email) email: string
  @appStore.State(state => state.fullscreenLoading) fullscreenLoading: boolean
  @appStore.State(state => state.authMethod) authMethod: number
  @appStore.Action('loginOut') loginOut: Function
  async handleLoginOut () {
    try {
      if (this.authMethod === 0) {
        this.loginOut()
      } else {
        await this['$gAuth'].signOut()
        this.loginOut()
      }
    } catch (error) {
      console.error(error)
    }
  }
  toHistory (): void {
    this['$router'].push('/history').catch(() => { return })
  }
}
